import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';




@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor() { }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
          withCredentials: true,
          setHeaders: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
          body: request.body
        });

        return next.handle(request);
    }
}
